export const getPagesList = (pagination) => {
  const nbPages = Math.ceil(pagination.totalItems / pagination.itemsPerPage);
  return Array(nbPages)
    .fill()
    .map((_, index) => index + 1);
};

export const getPageSlug = (slug, page) => {
  return page === 1 ? slug : `${slug}-${page}`;
};
